import { assert_string_not_blank } from '@shared/asserts/utils_asserts';
import { assert_string_uuid } from '@shared/asserts/utils_asserts_string';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP__fields_by_id } from '@shared/types/types';

//todo: save to db as json on tool
export class DTO__generation_tool_grid2d_view extends DTO__base {
  /*
   *
   */
  static _class_name_static: string = ENUM__dto_class_name.GENERATION_TOOL_GRID2D_VIEW;

  /*
   *
   */

  static sort_by_name(a: DTO__generation_tool_grid2d_view, b: DTO__generation_tool_grid2d_view) {
    let name_a = a.group.toLowerCase().trim();
    let name_b = a.group.toLowerCase().trim();

    return name_a.localeCompare(name_b);
  }

  /*
   *
   */
  name!: string;

  //unique list of field ids
  fields_visible!: string[];
  //unique list of field ids
  fields_stored!: string[];

  //set of field aliases
  fields_visible__human_readable!: string[];

  //todo:uncomment
  field_row_id!: string;
  field_column_id!: string;

  field_id_info__has_affect_on_generation!: string;
  field_ids_info__items_amount!: string[];
  field_id_info__ml_asset!: string;

  group!: string;

  get_info_all_are_empty() {
    let ids = [this.field_id_info__has_affect_on_generation, ...this.field_ids_info__items_amount, this.field_id_info__ml_asset];

    let out = ids.every(id => !id.is_empty_uuid());

    return out;
  }

  /*
   *
   */

  constructor() {
    super();

    this.fields_visible = [];
    this.fields_visible__human_readable = [];

    this.fields_stored = [];

    [this.field_row_id, this.field_column_id] = [ENUM__string_id_empty.UUID, ENUM__string_id_empty.UUID];

    [this.field_id_info__has_affect_on_generation, this.field_ids_info__items_amount, this.field_id_info__ml_asset] = [
      ENUM__string_id_empty.UUID,
      [],
      ENUM__string_id_empty.UUID,
    ];

    this.group = '';
  }

  sync_with_graph_fields(field_map: MAP__fields_by_id) {
    this.fields_visible = this.fields_visible.filter(field_id => field_map.has(field_id));
    this.fields_stored = this.fields_stored.filter(field_id => field_map.has(field_id));

    if (!field_map.has(this.field_row_id)) this.field_row_id = ENUM__string_id_empty.UUID;
    if (!field_map.has(this.field_column_id)) this.field_column_id = ENUM__string_id_empty.UUID;
  }

  is_equal(other: DTO__generation_tool_grid2d_view) {
    if (this.field_row_id != other.field_row_id) return false;
    if (this.field_column_id != other.field_column_id) return false;

    /*
     *
     */

    let fields_visible_set_this = new Set(this.fields_visible);
    let fields_visible_set_other = new Set(other.fields_visible);

    if (!fields_visible_set_this.is_equal(fields_visible_set_other)) return false;

    /*
     *
     */

    let fields_stored_set_this = new Set(this.fields_stored);
    let fields_stored_set_other = new Set(other.fields_stored);

    if (!fields_stored_set_this.is_equal(fields_stored_set_other)) return false;

    return true;
  }

  /*
   *
   */

  assert_standard_fields() {
    assert_string_not_blank(this.name);

    assert_string_uuid(this.field_row_id);
    assert_string_uuid(this.field_column_id);
  }
}
